import { RoutesString } from 'common-modules/general/Config/routesString';
import { useEffect } from 'react';
import { Redirect } from 'react-router';
import { useLocation } from 'react-router-dom';
import Content from './DetailPage';
import './OpenPage.scss';
import { observer, useLocalObservable } from 'mobx-react';
import FooterEventModel from 'common-modules/general/Common/Logic/Event/EventCommon';

const FooterEvent02 = observer(() => {
  const params = useLocation();
  const id = params.search.replace('?id=', '');

  const { model: eventModel } = useLocalObservable(() => ({ model: new FooterEventModel() }));

  useEffect(() => {
    if (id) {
      eventModel.getEventDetailData(id);
    }
  }, [id]);

  const eventDetailData = eventModel.eventDetail.data;

  if (location && eventDetailData && eventModel.eventDetail.loadStatus === 'READY') {
    return (
      <div className="footer-event-02">
        <div className="container mt-120">
          <div className="h-title-area">
            <h2 className="h-title">이벤트</h2>
          </div>
        </div>
        <Content data={eventDetailData} />
      </div>
    );
  } else if (eventModel.eventDetail.loadStatus === 'PENDING') {
    return <div style={{height: "1000px"}}></div>;
  } else {
    return <Redirect to={RoutesString.SalesEvent} />;
  }
});

export default FooterEvent02;
